// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from "firebase/compat/app";
import "firebase/compat/auth"
import "firebase/compat/firestore"
const firebaseConfig = {
    apiKey: "AIzaSyCvIdxfz1tG8mhD-DP464aes7ndb6WXJwg",
    authDomain: "shibucord.firebaseapp.com",
    projectId: "shibucord",
    storageBucket: "shibucord.appspot.com",
    messagingSenderId: "965927417679",
    appId: "1:965927417679:web:b2fb54d10711c058a5373a",
    measurementId: "G-56ZTL06JWJ"
  };
  const firebaseApp = firebase.initializeApp(firebaseConfig);
  const db =  firebaseApp.firestore();
 const auth= firebase.auth()
 const serverTimestamp = firebase.firestore.FieldValue.serverTimestamp()
 export{db, auth, serverTimestamp}
 export default firebase;